import i18next from 'i18next'

const MAX_FILE_SIZE_MB = 50
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024

export type FileValidationError =
	| { type: 'file-too-large'; sizeInMB: number; maxSizeInMB: number }
	| { type: 'invalid-type'; fileType: string }

export function validateImageFile(file: File): FileValidationError | null {
	// Check file size
	if (file.size > MAX_FILE_SIZE_BYTES) {
		return {
			type: 'file-too-large',
			sizeInMB: Math.round((file.size / (1024 * 1024)) * 10) / 10,
			maxSizeInMB: MAX_FILE_SIZE_MB,
		}
	}

	// Must match the backend Media attribute's DEFAULT_EXTENSIONS (jpeg/jpg/jpe/png/webp/svg/avif)
	const ALLOWED_MIME_TYPES = new Set([
		'image/jpeg',
		'image/png',
		'image/webp',
		'image/svg+xml',
		'image/avif',
	])

	if (!ALLOWED_MIME_TYPES.has(file.type)) {
		return {
			type: 'invalid-type',
			fileType: file.type,
		}
	}

	return null
}

export function formatFileValidationError(error: FileValidationError): string {
	switch (error.type) {
		case 'file-too-large':
			return i18next.t('editor:imageValidation.tooLarge', { size: error.sizeInMB, max: error.maxSizeInMB })
		case 'invalid-type':
			return i18next.t('editor:imageValidation.invalidType', { type: error.fileType || 'unknown type' })
	}
}
